import { actionTypes } from '../actions';
import initialState from '../initial';

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTION_FAILURE:
      return {
        ...state,
        errorMessage: action.payload,
        actionProcessing: false,
      };

    case actionTypes.ACTION_PROCESSING:
      return {
        ...state,
        actionProcessing: true,
      };

    case actionTypes.ACTION_PROCESSING_BY_PROVIDER:
      const { provider, value } = action.payload;
      return {
        ...state,
        actionProcessingByProvider: {
          ...state.actionProcessingByProvider,
          [provider]: value,
        },
      };

    case actionTypes.ACTION_PROCESSING_SUCCESS:
      return {
        ...state,
        actionProcessing: true,
      };

    case actionTypes.GET_GAME_LIST_SUCCESS:
      return {
        ...state,
        gameList: [...state.gameList, ...action.payload],
      };

    case actionTypes.GET_GAME_LIST_REPLACED:
      return {
        ...state,
        gameList: [
          ...state.gameList.filter(
            t => t.routeProvider !== action.payload.provider || t.tab.indexOf('favorite') !== -1,
          ),
          ...action.payload.gameList,
        ],
      };

    case actionTypes.GET_GAME_LIST_SUCCESS_IN_FIELD:
      return {
        ...state,
        [action.payload.provider]: action.payload.gameList,
      };

    case actionTypes.GET_EXTRA_DATA_SUCCESS: {
      return {
        ...state,
        extraData: {
          [action.payload.provider]: {
            ...state.extraData[action.payload.provider],
            ...action.payload.data,
          },
        },
      };
    }

    case actionTypes.CLEAR_EXTRA_DATA:
      return {
        ...state,
        extraData: {},
      };

    case actionTypes.CLEAR_SESSION:
      return {
        ...state,
        gameUrl: '',
      };

    case actionTypes.LOAD_SESSION:
      return {
        ...state,
        gameUrl: action.payload,
      };

    case actionTypes.SET_CONTAINER_PROPS: {
      const { onScroll, containerRef } = action.payload;
      return {
        ...state,
        onScroll,
        containerRef,
      };
    }

    case actionTypes.INJECT_PROVIDER: {
      const { provider: provider1, providerFrom } = action.payload;
      return {
        ...state,
        gameList: [
          ...state.gameList.filter(item => item.routeProvider !== provider1),
          ...state.gameList
            .filter(item => item.routeProvider === providerFrom)
            .map(item => ({
              ...item,
              provider: provider1,
              routeProvider: provider1,
            })),
        ],
      };
    }

    default:
      return { ...state };
  }
}

export default reducer;
